module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/5/5-6989ad91570a60241be35e149e393e14.jpg";